export const PROFILE_CANAL_OPTIONS = [
  { value: "MULTIMARCA", label: "Multimarca" },
  { value: "LOJA_PROPRIA", label: "Loja Própria" },
  { value: "FRANQUIA", label: "Franquia" },
];

export const PROFILE_TIPO_PESSOA_OPTIONS = [
  { value: "REPRESENTANTE", label: "Representante" },
  { value: "LOJISTA", label: "Lojista" },
  { value: "FRANQUIA", label: "Franquia" },
  { value: "SUPERVISOR", label: "Supervisor" },
  { value: "VENDEDOR", label: "Vendedor" },
];

export function getProfileOptionLabel(options, value) {
  return options.find((option) => option.value === value)?.label || value;
}
